import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { inquiries } from "./inquiries/slice";
import { auth } from "./auth/slice";
import { myInquiries } from "./myInquiries/slice";
import { currentInquiry } from "./currentInquiry/slice";
import { clones } from "./clones/slice";
import { myClones } from "./myClones/slice";
import { currentClone } from "./currentClone/slice";
import { industries } from "./industries/slice";
import { investments } from "./investments/slice";
import { prices } from "./prices/slice";
import { soldInformations } from "./soldInformations/slice";
import { countries } from "./countries/slice";
import { cloneTypes } from "./cloneTypes/slice";
import { users } from "./users/slice";
import { currentUser } from "./currentUser/slice";
import { favorites } from "./favorites/slice";
import { watchlist } from "./watchlist/slice";
import { filters } from "./filters/slice";
import { deals } from "./deals/slice";
import { currentDeal } from "./currentDeal/slice";
import { chat } from "./chat/slice";
import { message } from "./message/slice";
import { blog } from "./blog/slice";
import { currentBlog } from "./currentBlog/slice";
import { contactUs } from "./contactUs/slice";
import { metadata } from "./metadata/slice";

export const store = configureStore({
  reducer: combineReducers({
    currentUser,
    auth,
    inquiries,
    myInquiries,
    currentInquiry,
    clones,
    myClones,
    currentClone,
    industries,
    investments,
    prices,
    soldInformations,
    countries,
    cloneTypes,
    users,
    favorites,
    watchlist,
    filters,
    deals,
    currentDeal,
    chat,
    message,
    blog,
    currentBlog,
    contactUs,
    metadata,
  }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
